/* eslint-env browser */
/* global $ */

import Fuse from 'fuse.js';

const fuseOptions = {
	include: ['matches'],
	shouldSort: true,
	threshold: 0.1,
	// tokenize: true,
	location: 0,
	distance: 300,
	maxPatternLength: 32,
	keys: ['name', 'family_code']
};
const $input = $('.search-form input[name="name"]');
const $resultsWrapper = $('.search-form__result-container');
const $results = $('.search-form__results');
const $resultsContainer = $('.search-form__results .content-width-narrow');
const $noResults = $('.search-form__no-results');
const $btnClose = $('.search-form__result-container [data-action="close-results"]');

let items;
let fuse;
let $resultTemplate;

function emptyResults() {
	$resultsContainer.html('');
}

function splitByIndexes(string, indexes) {
	const parts = [];

	indexes.forEach((val, i) => {
		if (i === indexes.length - 1) {
			parts.push(string.substring(val + 1));
		} else if (i === 0) {
			parts.push(string.substring(val, indexes[i + 1]));
		} else {
			parts.push(string.substring(val, indexes[i + 1] + 1));
		}
	});

	// console.log(indexes);
	// console.log(parts);

	return parts;
}

function markSplittedString(stringArray) {
	const len = stringArray.length;

	stringArray.forEach((part, i) => {
		if (i !== 0 && i !== len - 1) {
			stringArray[i] = `<mark>${part}</mark>`;
		}
	});

	return stringArray.join('');
}

function setResults(resultsArray) {
	let html = '';
	let $templateItem;
	let name;
	let familyCode;
	let indexes;
	let splittedString;

	resultsArray.forEach((el) => {
		$templateItem = $resultTemplate.clone();

		name = el.item.name;
		familyCode = el.item.family_code;

		el.matches.forEach((match) => {

			if (match.key === 'name') {
				indexes = [0];
				match.indices.forEach((indice) => {
					if (indice[1] - indice[0] > 1) {
						indexes.push(indice[0]);
						indexes.push(indice[1]);
					}
				});

				splittedString = splitByIndexes(name, indexes);
				name = markSplittedString(splittedString);
			}

			if (match.key === 'family_code') {
				indexes = [0];
				match.indices.forEach((indice) => {
					if (indice[1] - indice[0] > 1) {
						indexes.push(indice[0]);
						indexes.push(indice[1]);
					}
				});

				splittedString = splitByIndexes(familyCode, indexes);
				familyCode = markSplittedString(splittedString);
			}
		});

		$templateItem.attr('href', el.item.link);
		$templateItem.html(`${name} <span class="family">${familyCode}</span>`);
		html += $templateItem[0].outerHTML;
	});

	$resultsContainer.html(html);
}

function handleVisibility() {
	const inputCount = $input.val().length;
	const resultCount = $('.search-form__result').length;
	const time = 150;

	$resultsWrapper.removeClass('is--active');

	if (resultCount > 0 && !$results.hasClass('is--active')) {
		$results.addClass('is--active').stop().slideDown(time);
	}

	if (resultCount < 1 && $results.hasClass('is--active')) {
		$results.removeClass('is--active').stop().slideUp(time);
	}

	if (inputCount > 0 && !$noResults.hasClass('is--active')) {
		$noResults.addClass('is--active').stop().slideDown(time);
	}

	if ((inputCount < 1 || resultCount > 0) && $noResults.hasClass('is--active')) {
		$noResults.removeClass('is--active').stop().slideUp(time);
	}

	if ($noResults.hasClass('is--active') || $results.hasClass('is--active')) {
		$resultsWrapper.addClass('is--active');
	}
}

function handleSearch() {
	const val = $input.val();
	let search;

	if (val.length > 2) {
		search = fuse.search(val);
		setResults(search);
	} else {
		emptyResults();
	}

	handleVisibility();
}

function init() {

	if (!$('.search-form').length) { return; }

	items = JSON.parse($('#search-form__items-json').html());
	fuse = new Fuse(items, fuseOptions);
	$resultTemplate = $results.find('[data-template]').clone();
	$resultTemplate.removeAttr('data-template');
	$results.find('[data-template]').remove();
	// $results.slideUp(10);

	$input.on('keyup change', handleSearch);
	$input.on('focus blur', handleVisibility);

	$btnClose.on('click', () => {
		$input.val('').trigger('change');
	});
}

export default {
	init
};
